var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.028,
    height: 10.994,
    viewBox: "0 0 219.028 10.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2753_00000008834289966381704450000011925770069466350471_",
    x2: 210.393,
    transform: "translate(1.672 5.35)",
    fill: "none",
    stroke: "#b4b0b0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3003_00000009576542215720439840000008604227282842667657_",
    transform: "translate(69.637 0.294)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 5.35,
    cy: 5.35,
    rx: 5.35,
    ry: 5.35,
    transform: "translate(0)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_402",
    "data-name": "Ellipse 402",
    cx: 4.35,
    cy: 4.35,
    rx: 4.35,
    ry: 4.35,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3004_00000010997005626615357980000002113123598191090357_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_403",
    "data-name": "Ellipse 403",
    cx: 5.35,
    cy: 5.35,
    rx: 5.35,
    ry: 5.35,
    transform: "translate(0)",
    fill: "#1d70b8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_404",
    "data-name": "Ellipse 404",
    cx: 4.35,
    cy: 4.35,
    rx: 4.35,
    ry: 4.35,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#1d70b8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3005_00000087404964724929368990000015650482240079996581_",
    transform: "translate(140.531 0.294)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 5.35,
    cy: 5.35,
    rx: 5.35,
    ry: 5.35,
    transform: "translate(0)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_406",
    "data-name": "Ellipse 406",
    cx: 4.35,
    cy: 4.35,
    rx: 4.35,
    ry: 4.35,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3006_00000165916790093161237600000009243879972709662391_",
    transform: "translate(208.328 0.294)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 5.35,
    cy: 5.35,
    rx: 5.35,
    ry: 5.35,
    transform: "translate(0)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_408",
    "data-name": "Ellipse 408",
    cx: 4.35,
    cy: 4.35,
    rx: 4.35,
    ry: 4.35,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizards);
export default __webpack_public_path__ + "static/media/Wizards.3084e57f6dd6fe8d88e33eda6755a1dc.svg";
export { ForwardRef as ReactComponent };